/**
 * @desc deleteById
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(id: string | number, options?: any) {
  return updateResponse(
    http(URL + `/inDetailBox/${id}`, {
      method: "DELETE",

      ...options,
    }),
  );
}
